module.exports = __webpack_public_path__ + "static/media/pg02.ec6aaf77.jpg";